import clsx from 'clsx';
import { CSSProperties } from 'react';
import * as React from 'react';

import styles from './Button.module.scss';

export enum ButtonWidth {
  Content = 'content',
  Fullwidth = 'fullwidth',
}

export enum ButtonColor {
  Default = 'default',
  Primary = 'primary',
  Secondary = 'secondary',
  Danger = 'danger',
  SuperDanger = 'super-danger',
}

type ButtonProps = {
  id?: string;
  type?: 'submit' | 'button';
  title?: string;
  color?: ButtonColor;
  width?: ButtonWidth;
  className?: string;
  disabled?: boolean;
  iconComponent?: React.ReactNode;
  iconAlt?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  testId?: string;
} & Pick<React.ButtonHTMLAttributes<HTMLButtonElement>, 'autoFocus' | 'style'>;

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  function Button(props, ref) {
    const {
      title,
      color,
      width,
      className,
      disabled,
      iconComponent,
      testId,
      ...rest
    } = {
      ...DefaultProps,
      ...props,
    };

    const buttonStyles = [
      className,
      styles.button,
      styles[`${width}-button`],
      styles[`${color}-button`],
    ];
    return (
      <button
        ref={ref}
        type={props.type ?? 'button'}
        data-disabled={disabled}
        disabled={disabled ? true : undefined}
        {...rest}
        className={clsx(buttonStyles)}
        data-test-id={props.testId}
      >
        {iconComponent}
        {title}
      </button>
    );
  },
);

const DefaultProps: Partial<ButtonProps> = {
  color: ButtonColor.Default,
  width: ButtonWidth.Content,
};
